import React from 'react';
import { useT } from 'client/i18n/hooks/useT';

export function HeroPhone({
  text = '01:24',
  width = 355,
}: {
  text?: string;
  width?: number | string;
}) {
  const t = useT();
  return (
    <svg
      width={width}
      viewBox="0 0 355 500"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t(
        'FeaturesScreen.HeroPhone.PhoneRecordingImageAriaLabel',
        'A wireframe of a phone running Anchor, with a dot indicating that a recording is happening',
        'Phone using Anchor and recording audio image screenreader information'
      )}
    >
      <defs>
        <linearGradient x1="50%" y1="0" x2="50%" y2="100%" id="gradient">
          <stop stopColor="#fff" offset="35.94%" />
          <stop stopColor="#fff" stopOpacity="0" offset="76.56%" />
        </linearGradient>
      </defs>
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <g transform="translate(109 73)">
          <circle fill="#f66181" fillRule="nonzero" cx="8" cy="8" r="8" />
          <text
            fontFamily="Maax, monospace"
            fontSize="21"
            fontWeight="900"
            fill="#fff"
            style={{ userSelect: 'none' }}
          >
            <tspan x="80" y="15" textAnchor="middle">
              {t(
                'FeaturesScreen.HeroPhone.RecordingLabel',
                'Recording',
                'Recording label for an image of a phone recording audio'
              )}
            </tspan>
          </text>
          <path
            d="M67.46 423.91a60.46 60.46 0 100-120.91 60.46 60.46 0 000 120.91z"
            fill="#f66181"
          />
          <path
            d="M75.52 364.1a8.75 8.75 0 01-8.74 8.76 8.75 8.75 0 01-8.73-8.76v-18.76a8.75 8.75 0 018.73-8.75 8.75 8.75 0 018.74 8.75v18.77zm2.24-9.79c0-.88.7-1.6 1.56-1.6.87 0 1.57.72 1.57 1.6v9.61c0 7.41-5.5 13.53-12.54 14.33v8.87h5.29c.86 0 1.57.72 1.57 1.6 0 .89-.7 1.6-1.57 1.6h-13.7c-.88 0-1.58-.71-1.58-1.6 0-.88.7-1.6 1.57-1.6h5.29v-8.87a14.33 14.33 0 01-12.54-14.33v-9.6c0-.9.7-1.61 1.56-1.61.87 0 1.57.72 1.57 1.6v9.61a11.1 11.1 0 0010.97 11.22 11.1 11.1 0 0010.98-11.22v-9.6z"
            fill="#fff"
          />
        </g>
        <rect
          opacity="0.3"
          stroke="url(#gradient)"
          strokeWidth="2.88"
          x=".44"
          y=".44"
          width="352.12"
          height="657.12"
          rx="38.87"
        />
        <text
          fontFamily="MaaxMono, Maax, monospace"
          fontSize="50"
          fontWeight="bold"
          fill="#fff"
          style={{ userSelect: 'none' }}
        >
          <tspan x="50%" y="235" textAnchor="middle">
            {text}
          </tspan>
        </text>
      </g>
    </svg>
  );
}
